export enum InstanceStatusType {
	Open = 1,
	DeadlineExceeded = 2,
	Completed = 3
}